import { useNavigate } from "react-router-dom";

const checklistItems = [
  "Real-time queries across ChatGPT, Gemini, and Claude with your exact search terms.",
  "Side-by-side ranking of every hotel each AI model mentions — and where you stand.",
  "Actionable insights on why some competitors rank higher in AI responses.",
];

const AIDiscoverySection = () => {
  const navigate = useNavigate();
  return (
    <section className="py-32 px-8 bg-surface-container-low">
      <div className="max-w-8xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative rounded-2xl overflow-hidden aspect-video shadow-2xl">
            <img
              src="./Landing_Page_Image_2.png"
              alt="Modern luxury hotel lobby with warm ambient lighting and city skyline"
              className="w-full h-full object-fill"
              loading="lazy"
              width={800}
              height={500}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-on-surface/80 to-transparent flex items-end p-8">
              <div className="text-on-primary">
                <h4 className="font-headline text-xl font-bold">Visibility in Context</h4>
                <p className="text-sm opacity-80">
                  We map physical hospitality to digital semantic landscapes.
                </p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary font-label text-[10px] font-extrabold tracking-[0.15em] mb-6 uppercase">
              AI Search Optimization
            </span>

            <h2 className="font-headline text-4xl font-extrabold mb-6 leading-tight">
              See How AI Search Engines <br /> Recommend Your Hotel.
            </h2>

            <p className="text-on-surface-variant text-lg leading-relaxed mb-8">
              When a traveler asks ChatGPT or Gemini for hotel recommendations in your city, does
              your property come up? Our LLM Visibility tool queries real AI models with real
              prompts and shows you exactly where you rank.
            </p>

            <ul className="space-y-4">
              {checklistItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="material-symbols-outlined text-primary mt-1 font-bold">
                    check_circle
                  </span>
                  <span className="text-on-surface font-medium">{item}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={() => {
                navigate("/llm-visibility");
              }}
              className="mt-10 bg-gradient-to-br from-primary to-primary-container text-on-primary px-10 py-4 rounded-xl font-bold text-lg hover:opacity-90 transition-opacity"
            >
              Explore LLM Visibility
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIDiscoverySection;
